import React, { useState } from 'react';
import { Button, notification } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { PlusOutlined } from '@ant-design/icons';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var ClassRoundSource = models.rounds.ClassRoundSource;
import { RoundType } from '@vote4dance/judging-schema';
export const RoundAddTeamsButton = (props) => {
    const { round, size, disabled } = props;
    const classRoundSource = ClassRoundSource(round.class_id);
    const [loadingAddTeams, setLoadingAddTeams] = useState(false);
    const [rounds, loadingRounds] = Stream(classRoundSource);
    const parentRound = rounds && rounds.find((a) => a.round_id === round.round_parent_id);
    const canAddTeams = round.round_new_teams > 0 || (round.round_type == RoundType.Normal && parentRound && parentRound.round_new_teams > 0);
    const addTeams = () => {
        setLoadingAddTeams(true);
        const roundToUpdate = (parentRound && parentRound.round_new_teams > 0) ? parentRound : round;
        Api.call(`${classRoundSource.url}/${roundToUpdate.round_id}`, "add-teams")
            .then(() => {
            setLoadingAddTeams(false);
        })
            .catch((err) => {
            setLoadingAddTeams(false);
            notification.error({
                message: _T(err.name)
            });
        });
    };
    if (!canAddTeams) {
        return null;
    }
    return (React.createElement(Button, { key: "add", size: size, type: "primary", icon: React.createElement(PlusOutlined, null), disabled: disabled, onClick: addTeams, loading: loadingAddTeams }, _T('round.addTeams.label')));
};
